import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { CiEdit } from 'react-icons/ci';
import { RiGalleryUploadLine } from 'react-icons/ri';

interface banner {
  title: string;
  content: string;
  id: number;
  image: string;
  pageName: String;
  is_active?: number;
}

const DirectorsBanner = () => {

  const [selectedPostId, setSelectedPostId] = useState<string | null>(null);
  const [bannerdata, setBannerdata] = useState<banner[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Open modal
  const openModal = (postId: string) => {
    setSelectedPostId(postId);
    setIsModalOpen(true);
  };

  // Function to close modal and clear the post ID
  const closeModal = () => {
    setSelectedPostId(null);
    setIsModalOpen(false);
  };

  const toggleStatus = async (id: number, currentStatus?: number) => {
    const newStatus = currentStatus === 0 ? 1 : 0;
    try {
      await axios.put(`https://rmbbackend.rmbjaipur.com/auth/banner/toggle-status/${id}`, { is_active: newStatus });
      setBannerdata(prev => prev.map(item => item.id === id ? { ...item, is_active: newStatus } : item));
      alert(`Banner status updated to ${newStatus === 1 ? 'ACTIVE (Live)' : 'INACTIVE (Hidden)'}`);
    } catch (error) {
      console.error('Error toggling status:', error);
      alert('Failed to update status.');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<banner[]>(
          "https://rmbbackend.rmbjaipur.com/auth/directorbanner?all=true");

        setBannerdata(response.data || []);
      } catch (error) {
        console.error("banner Not Found:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <div className='p-6 space-y-4'>
        {bannerdata.map((item) => (
          <div key={item.id} className='w-full rounded-2xl bg-slate-900 border border-slate-700 text-slate-100 p-5 space-y-4 shadow-xl'>
            <div className='flex flex-wrap justify-between items-center gap-2 border-b border-slate-800 pb-3'>
              <div className="flex items-center gap-3">
                <h1 className='text-xl font-black text-white'>Banner for {item.pageName}</h1>
                <div className={`px-3 py-1 rounded-full text-xs font-black uppercase shadow border ${item.is_active === 0 ? 'bg-red-950 text-red-300 border-red-500/60' : 'bg-emerald-950 text-emerald-300 border-emerald-500/60'
                  }`}>
                  {item.is_active === 0 ? '🔴 INACTIVE (Hidden)' : '🟢 ACTIVE (Live)'}
                </div>
              </div>

              <div className="flex items-center gap-2">
                <button
                  onClick={() => toggleStatus(item.id, item.is_active)}
                  className={`px-4 py-2 rounded-lg text-xs font-bold transition flex items-center gap-1.5 cursor-pointer border ${item.is_active === 0
                    ? 'bg-emerald-600/20 hover:bg-emerald-600 text-emerald-300 border-emerald-500/40 hover:text-white'
                    : 'bg-red-600/20 hover:bg-red-600 text-red-300 border-red-500/40 hover:text-white'
                    }`}
                >
                  {item.is_active === 0 ? '🟢 Set Active' : '🔴 Set Inactive'}
                </button>

                <button
                  className='px-4 py-2 border border-blue-500/60 hover:bg-blue-600 text-blue-300 hover:text-white font-bold text-xs rounded-lg gap-1 flex items-center cursor-pointer'
                  onClick={() => openModal(item.id + "")}
                >
                  <CiEdit size={16} /> Edit Banner
                </button>
              </div>
            </div>

            <div className='flex flex-col sm:flex-row items-center gap-4'>
              <img
                className="h-[120px] w-[230px] object-cover rounded-xl bg-slate-950 border border-slate-800"
                src={
                  item.image
                    ? item.image.startsWith("http")
                      ? item.image
                      : `https://rmbbackend.rmbjaipur.com/${item.image.replace(/^\//, '')}`
                    : "https://via.placeholder.com/150"
                }
                alt={item.title || "Image"}
              />
              <div className='flex-1 space-y-1 text-left'>
                <h2 className='text-lg font-bold text-white'>{item.title}</h2>
                <p className="text-slate-400 text-xs leading-relaxed">{item.content}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg w-[50%] h-auto">
            {/* <button onClick={closeModal} className="text-red-500 font-bold absolute top-4 right-4">
              X
            </button> */}
            <Modal postId={selectedPostId} onClose={closeModal} />
          </div>
        </div>
      )}
    </div>
  )
}

interface ModalProps {
  postId?: string | null;
  onClose: () => void;
}

const Modal: React.FC<ModalProps> = ({ postId, onClose }) => {


  const [formData, setFormData] = useState({
    title: '',
    content: '',
    image: null as File | null,

  });
  const [fileName, setFileName] = useState<string | null>(null);
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (postId) {
      const fetchPost = async () => {
        try {
          const response = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/directorbanner/${postId}`);


          const data = Array.isArray(response.data) ? response.data[0] : response.data;
          // Access the first element

          // Destructure from the first element of the array
          const { title, content, image: image } = data;


          console.log("Title:", title);
          console.log("Content:", content);
          console.log("Image:", image);
          setFormData({
            title,
            content,
            image: image || null,

          });

          setFileName(image);
        } catch (err) {
          console.error('Error fetching post:', err);
        }
      };
      fetchPost();
    }
  }, [postId]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] || null;
    setFormData((prev) => ({ ...prev, image: file }));
    setFileName(file ? file.name : null);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate fields
    if (!formData.title || !formData.content) {
      setError('All fields are required.');
      return;
    }



    const data = new FormData();
    data.append('title', formData.title);
    data.append('content', formData.content);
    if (formData.image) { data.append('image', formData.image); }

    else if (fileName) {

      data.append('image', fileName);
    }



    console.log('Data data ' + formData.image);
    console.log('filename ' + fileName);

    console.log('Submitting form data:', {
      title: formData.title,
      content: formData.content,
      image: formData.image,
    });

    try {
      if (postId) {
        await axios.put(`https://rmbbackend.rmbjaipur.com/auth/directorbanner/${postId}`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        console.log('banner updated successfully');
      }
      onClose();
      window.location.href = '/dashboard';
    } catch (err) {
      console.error('Error submitting post:', err);
      setError('Failed to submit the post. Please try again.');
    }
  };


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white w-1/2 p-6 rounded shadow relative">

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Title */}
          <div>
            <label className="text-[#030303] font-medium"> Post title</label>
            <div className=" mt-1 w-[100%]  h-[50px]  border px-2 border-[#94A2B8] rounded-lg flex justify-center items-center mb-4 ">
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Write your post title here..."
                className="w-full bg-transparent placeholder-[#94A2B8] outline-none text-[14px]"
                required
              />
            </div>
          </div>


          {/* Content */}
          <div>
            <label className="text-[#030303] font-medium">Description</label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleChange}
              className="mt-1 mb-4 p-2 block w-full h-[150px] border-[1px] border-[#94A2B8] rounded-md outline-none shadow-sm text-[14px]"
              placeholder="Write your message here..."
              rows={4}
              required
            />
          </div>


          {/* File Upload */}
          <div>
            <label className="text-[#030303]  font-medium">  Add media</label>
            <div className="mt-1 w-[100%] h-[200px] border-dashed px-2 border-[2px] border-[#94A2B8] rounded-lg flex flex-col justify-center items-center mb-4">

              <RiGalleryUploadLine size={24} className="text-[30px] cursor-pointer"
                onClick={() => document.getElementById('file-upload')?.click()} />
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                className="hidden"
                name='image'

                onChange={handleFileChange}


              />
              {fileName ? (
                <p className="text-[14px] text-[#02256d] mt-2">
                  Selected file: <span className="font-bold">{fileName}</span>
                </p>
              ) : (
                <p className="font-bold text-[14px]">
                  Drag and Drop or{' '}
                  <span className="text-[#02256d]">click to upload</span>
                </p>
              )}
            </div>

          </div>

          {/* Error Message */}
          {error && <p className="text-red-500">{error}</p>}


          <div className=' flex justify-between'>

            {/*Cancel form button*/}
            <button className='mt-[22px] mx-[10px] border-[#94A2B8] border px-[20px] py-[10px] rounded-md hover:bg-[#FDBC12] hover:border-none text-[14px] font-bold' onClick={onClose}>Cancel</button>
            {/* Submit Button */}
            <button
              type="submit"
              className='mt-[22px] bg-[#FDBC12] px-[20px] py-[10px] rounded-md hover:border-[#94A2B8] hover:border hover:bg-[#fdba1200] text-[14px]  cursor-pointer font-semibold'
              disabled={!formData.title || !formData.content}
            >
              {postId ? 'Update Slider' : 'Create Slider'}
            </button>
          </div>






        </form>
      </div>
    </div>
  );
};
export default DirectorsBanner